// extracted by mini-css-extract-plugin
export default {"wrapper":"StarOutline_wrapper__h2evl","large":"StarOutline_large__YomeQ","medium":"StarOutline_medium__YbweF","small":"StarOutline_small__emqrQ"};